import java from '../../assets/images/java.png';
import sqlServer from '../../assets/images/sql-server.png';
import api from '../../assets/images/api.png';
import spring from '../../assets/images/spring.png';
import docker from '../../assets/images/docker.png';
import csharp from '../../assets/images/c-sharp.png';
import aws from '../../assets/images/web.png';
import nodejs from '../../assets/images/nodejs.png';
import react from '../../assets/images/react.png';
import android from '../../assets/images/android.png';
import mongodb from '../../assets/images/mongodb.png'; 
import git from '../../assets/images/git.png'; 
import visualBasic from '../../assets/images/visual-basic.png'; 
import html from '../../assets/images/html.png'; 
import css from '../../assets/images/css.png'; 
import js from '../../assets/images/javascript.png'; 

const images = { 
  java,
  sqlServer,
  api,
  spring,
  docker,
  csharp,
  aws,
  nodejs,
  react,
  android,
  mongodb, 
  git, 
  visualBasic, 
  html, 
  css, 
  js, 
};

export default images;